import React, { useState, useEffect } from 'react'
import FormInput from "../../../common/form/form-input";
import FormTextarea from "../../../common/form/form-textarea";
import FormSelect from '../../../common/form/form-select';
import TogglePanel from '../../../common/toggle-panel';
import { fetchStates } from '../../../../modules/locations'
function Address(props) {
  const [location, setLocation] = useState(props.location);
  const [states, setStates] = useState([])

  useEffect(function () {
    setLocation(props.location)
  }, [props.location])

  useEffect(() => {
    fetchStates()
      .then((data) => {
        let _states = data.map((ele) => ( { value: ele.id, label: ele.name }));
        setStates(_states);
      })

  }, [])

  return (
    <div className="mx-auto max-w-7xl px-6 pb-6">
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" id='address'>
          <TogglePanel name='Address' initOpen={true}>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
              <div className="py-4 sm:py-5 sm:px-6">
                <h3 className="text-base/7 font-semibold text-gray-900">Details</h3>
              </div>
              <dl className="border-t border-gray-200 sm:divide-y sm:divide-gray-200">
                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>Address</strong></h3>
                    <p className="font-weight-light">
                      Primary Address
                    </p>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.address}
                      field="address"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>
                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h4><strong>Directions</strong></h4>
                    <p className="font-weight-light">
                      Helpful instructions for drivers
                    </p>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormTextarea
                      value={location.directions}
                      field="directions"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>City</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.city}
                      field="city"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>County</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.county}
                      field="county"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>State</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormSelect
                      value={location.state_id}
                      field="state_id"
                      handleChange={props.updateField}
                      className="bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 w-full p-2.5"
                      options={states}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>Zipcode</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.zipcode}
                      field="zipcode"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>Country</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.country}
                      field="country"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:px-6">
                  <h3 className="text-base/7 font-semibold text-gray-900">Geo Cordinates</h3>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>Latitude</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.latitude}
                      field="latitude"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>

                <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    <h3><strong>Longitude</strong></h3>
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                    <FormInput
                      value={location.longitude}
                      field="longitude"
                      className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                      updateField={props.updateField}
                    />
                  </dd>
                </div>
              </dl>
            </div>
          </TogglePanel>
      </div>
    </div>
  )
}

export default Address;